export default interface INota {
    Id: number;
    Id_Account: number;
    Data: string;
    Testo: string;
    Creation: string;
    Timestamp: string;
}

export const exampleNota: INota = {
    Id: 0,
    Id_Account: 0,
    Data: '',
    Testo: '',
    Creation: '',
    Timestamp: '',
};